/**
 * 客户端分享
 */
import { nativeApi } from '@dym/client-bridge';

class DYAppShare {
    constructor (config) {
        this.config = Object.assign({
            // 分享配置
            shareSetting: {
                // 标题
                title: '',
                // 描述
                desc: '',
                // 链接
                link: '',
                // 图片
                imgUrl: ''
            },
            // 分享成功回调
            success: null,
            // 取消分享回调
            cancel: null
        }, config);

        // 分享配置
        this.shareSetting = {
            title: this.config.shareSetting.title,
            content: this.config.shareSetting.desc,
            link: this.config.shareSetting.link,
            imageUrl: this.config.shareSetting.imgUrl,
            platform: 0,
            yubadata: '',
            from: 'douyu',
            type: 0
        };

        this.init();
    }

    // 斗鱼客户端分享初始化
    initAppShare () {
        nativeApi.jsNative.dySetShareInfo(this.shareSetting);
    }

    // 展示斗鱼客户端分享
    show () {
        nativeApi.jsNative.dyShareInfo(this.shareSetting);
    }

    init () {
        this.initAppShare();
    }
}

export default DYAppShare;
